import { j as o } from "./index58.mjs";
import { Modal as t } from "@mantine/core";
const m = (s) => {
  const a = `modal ${s.size}`, e = {
    ...s,
    shadow: "sm",
    radius: "md",
    withCloseButton: !1,
    centered: !0,
    classNames: {
      modal: a
    }
  };
  return /* @__PURE__ */ o.jsx(t, { ...e, ...s, children: s.children });
};
export {
  m as Modal
};
